'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '@/libs';

type LabelProps = HTMLAttributes<HTMLSpanElement> & {
  children?: ReactNode;
};

export const Label = ({ children, className, ...props }: LabelProps) => {
  return (
    <div className="flex items-center bg-primary w-fit px-3 min-h-7 rounded-3xl">
      <span
        className={cn('text-xs uppercase text-primary-foreground font-bold', className)}
        {...props}
      >
        {children}
      </span>
    </div>
  );
};
